import React from 'react';

const ConfigButton = ({ articleNumber, orderRow, presets, cssClass, label, onClick,isSavedCart,cartId }) => (
    <a className={cssClass} onClick={() => onClick(articleNumber, orderRow, presets,isSavedCart,cartId)} dangerouslySetInnerHTML={{__html: label}}></a>
)

export default ConfigButton;